const onSubmit = () => {
  let currentCustomer = {
    id: document.getElementsByName("customer_id")[0].id,
    email: document.getElementsByName("customer_email")[0].id,
    first_name: document.getElementsByName("customer_first_name")[0].id,
    last_name: document.getElementsByName("customer_last_name")[0].id,
    accepts_marketing: Boolean(document.getElementsByName("customer_accepts_marketing")[0].id)
  }
  let updatedCustomer = {
    id: document.getElementsByName("customer_id")[0].id,
    email: document.getElementById('customer_email').value,
    first_name: document.getElementById('customer_firstname').value,
    last_name : document.getElementById('customer_lastname').value,
    accepts_marketing: document.getElementById('marketing').checked
  }
  JSON.stringify(currentCustomer) === JSON.stringify(updatedCustomer) ? doRefresh() : doRequest(updatedCustomer)
}
  
const doRequest = (customer) => {
  const data = JSON.stringify(customer);
  const url = 'https://account-portal-nb.herokuapp.com/updatecustomer';
  const xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
  xhr.onreadystatechange= function() {
    if(xhr.readyState == 4) {
      doRefresh();
    }
  }
  xhr.send(data);
}

const doRefresh = () => {
  document.location.reload('true');
}

document.getElementById('customer_basic_info').addEventListener("submit", function(event) {
  onSubmit();
});